import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useDepartmentGroups } from '@/entities/department';
import { useIntermediateTask } from '@/features/tasks/model/useIntermediateTask';
import { useUsers } from '@/hooks/users/useUserActions';
import { useAuthStore } from '@/store/auth';

import { DesktopSidebarActiveTimer } from './DesktopSidebarActiveTimer';
import { DesktopSidebarFooter } from './DesktopSidebarFooter';
import { DesktopSidebarHeader } from './DesktopSidebarHeader';
import { DesktopSidebarMenu } from './DesktopSidebarMenu';

export function DesktopSidebar() {
  const { userId } = useAuthStore();
  const { data: user } = useUsers.useById(userId);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { groups = [], isLoading: groupsLoading } = useDepartmentGroups();
  const { createIntermediateTask, isLoading: isCreatingTask } =
    useIntermediateTask({ type: 'intermediate' });

  const [otdelsOpen, setOtdelsOpen] = useState(false);
  const [avatarOpen, setAvatarOpen] = useState(false);

  const selectedGroupId = pathname.match(/^\/groups\/(\d+)/)?.[1] ?? null;
  const selectedGroupName =
    groups.find((group) => String(group.ID) === selectedGroupId)?.Name ??
    'Отделы';

  return (
    <aside className="sticky top-0 z-30 mr-1 hidden h-screen w-[234px] shrink-0 overflow-hidden rounded-r-[20px] border-r border-[#EEF0F4] bg-white font-roboto text-[#4B5563] shadow-[0_10px_34px_rgba(17,24,39,0.08)] lg:flex 2xl:mr-2.5 pb-[clamp(4px,0.5vh,8px)]">
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex min-h-[73px] items-center px-3">
          <DesktopSidebarHeader
            avatarOpen={avatarOpen}
            user={user ?? undefined}
            onAvatarOpenChange={setAvatarOpen}
            onNavigate={navigate}
          />
        </div>

        <div className="px-3 pb-[8px]">
          <DesktopSidebarActiveTimer />
        </div>

        <DesktopSidebarMenu
          groups={groups}
          groupsLoading={groupsLoading}
          otdelsOpen={otdelsOpen}
          selectedGroupId={selectedGroupId}
          selectedGroupName={selectedGroupName}
          onNavigate={navigate}
          onOtdelsOpenChange={setOtdelsOpen}
        />

        <div className="px-3">
          <DesktopSidebarFooter
            userId={userId}
            isCreatingTask={isCreatingTask}
            onCreateIntermediateTask={createIntermediateTask}
            onControlClick={() => navigate('/?control=1')}
          />
        </div>
      </div>
    </aside>
  );
}
